import React from 'react'
import PropTypes from 'prop-types'

const FinalisationStep = ({
  fileName,
  sectionsCount,
  questionsCount
}) => (
  <div>
    <h6 className="font-weight-bolder mb-3">
      Récapitulatif de l&apos;importation
    </h6>
    <div className="alert alert-success-light d-flex align-items-center py-2 px-3 mb-0">
      <i className="fas fa-check-circle mr-2" />
      <span>
        <strong>{fileName}</strong>
        {' : '}
        {sectionsCount}
        {sectionsCount > 1 ? ' sections' : ' section'}
        {' et '}
        {questionsCount}
        {questionsCount > 1 ? ' questions' : ' question'}
        {' à importer'}
      </span>
    </div>
  </div>
)

FinalisationStep.propTypes = {
  fileName: PropTypes.string.isRequired,
  questionsCount: PropTypes.number.isRequired,
  sectionsCount: PropTypes.number.isRequired
}

export default FinalisationStep
